<template>
  <module-section :title="data.name">
    <div class="container">
      <section class="panel">
        <div class="item" v-for="(item, i) in data.contents" :key="i">
          <div class="tt">{{ item.name }}</div>
          <div class="intro">{{ item.intro }}</div>
          <div class="btn" @click="handleToArticle">{{ item.name }}</div>
        </div>
      </section>
      <div class="img"><img :src="data.img" /></div>
    </div>
  </module-section>
</template>

<script>
import ModuleSection from './ModuleSection.vue'

export default {
  components: {
    ModuleSection
  },
  props: {
    data: {
      type: Array,
      require: true
    }
  },
  methods: {
    handleToArticle(menu1Id, menu2Id) {
      this.$router.push({
        path: `/article/index?menu1Id=${ menu1Id }&menu2Id=${ menu2Id }`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
}

.img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 570px;
  display: flex;
  align-items: center;
  img {
    width: 630px;
  }
}

.panel {
  box-sizing: border-box;
  padding: 30px;
  width: 600px;
  background-color: rgb(217, 217, 217);
}

.item {
  margin-bottom: 20px;
  .tt {
    margin-bottom: 18px;
    font-size: 18px;
    font-weight: 700;
  }
  .intro {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .btn {
    font-size: 16px;
    cursor: pointer;
    color: #409eff;
  }
}
</style>
